import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import actionTypes from '../constants/reservation-new-action-types';

import type {Map} from 'immutable';

export type ReservationNewStore = {
    course: Map<unknown, unknown>;
};

const initialState = () => {
    return {
        course: Immutable.Map(),
    };
};

const actionsMap = {
    [actionTypes.DISPOSE]: () => {
        return initialState();
    },
};

export default createReducer<ReservationNewStore>(initialState(), actionsMap);
